import { message, Spin } from 'antd';
import React, { createContext, useState } from 'react';
import { putControleMigracao } from '../../services/controleMigracao';

export const Context = createContext({});

export function MigrationProvider(props) {
  const [migrationSelected, setMigrationSelected] = useState([]);
  const [filialSelected, setFilialSelected] = useState([]);
  const [isActiveMigrationSwitch, setIsActiveMigrationSwitch] = useState(false);
  const [migrations, setMigrations] = useState([]);
  const [loadingReprocessamento, setLoadingReprocessamento] = useState(false);

  const saveMigration = async () => {
    const filiaisMigracao = [];
    for (let i = 0; i < filialSelected.length; i++) {
      filiaisMigracao.push({
        id: 0,
        idFilial: filialSelected[i],
        idControleMigracao: 1,
        ativa: true,
      });
    }
    const payload = {
      id: 1,
      migracaoAtiva: isActiveMigrationSwitch,
      edicaoAutonomo: migrations.edicaoAutonomo,
      cadastroAutonomo: migrations.cadastroAutonomo,
      edicaoPropPFDistintos: migrations.edicaoPropPFDistintos,
      cadastroPropPFDistintos: migrations.cadastroPropPFDistintos,
      edicaoPropPFIguais: migrations.edicaoPropPFIguais,
      cadastroPropPFIguais: migrations.cadastroPropPFIguais,
      edicaoPropPJDistintos: migrations.edicaoPropPJDistintos,
      cadastroPropPJDistintos: migrations.cadastroPropPJDistintos,
      edicaoPropPJIguais: migrations.edicaoPropPJIguais,
      cadastroPropPJIguais: migrations.cadastroPropPJIguais,
      edicaoArrendatariosDistintos: migrations.edicaoArrendatariosDistintos,
      cadastroArrendatariosDistintos: migrations.cadastroArrendatariosDistintos,
      edicaoArrendatariosIguais: migrations.edicaoArrendatariosIguais,
      cadastroArrendatariosIguais: migrations.cadastroArrendatariosIguais,
      filiaisMigracao: filiaisMigracao.map(item => item),
    };
    try {
      setLoadingReprocessamento(true);
      const { status } = await putControleMigracao(payload);
      status === 200
        ? message.success('Dados foram salvos com sucesso.')
        : message.error(
            'Não foi possível salvar as alterações, tente novamente.'
          );
      setLoadingReprocessamento(false);
    } catch (error) {
      message.error('Erro ao salvar as alterações.');
      setLoadingReprocessamento(false);
    }
  };

  return (
    <Context.Provider
      value={{
        migrationSelected,
        setMigrationSelected,
        filialSelected,
        setFilialSelected,
        saveMigration,
        setMigrations,
        migrations,
        setIsActiveMigrationSwitch,
        isActiveMigrationSwitch,
      }}
    >
      <Spin
        spinning={loadingReprocessamento}
        size="large"
        style={{
          width: '100%',
        }}
        tip="Salvando dados de Migração"
        delay={200}
      >
        {props.children}
      </Spin>
    </Context.Provider>
  );
}
